import BlockContent from "../block-content";
import styled from "styled-components";
import tw from "twin.macro";
import Image from "gatsby-plugin-sanity-image";

const Intro = styled.div`
  p {
    ${tw`text-sm md:text-lg mb-8 md:mb-16`}
  }
`;

const RealWorldExperienceBlock = (props) => {
  const realWorldExperienceBlock = props.props ?? props.pageBlockGroup;
  return (
    <section className="py-8 md:py-16" key={realWorldExperienceBlock._key}>
      {(realWorldExperienceBlock?.title ||
        realWorldExperienceBlock?._rawBody) && (
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex">
            <div className="md:w-10/12 mx-auto">
              <hr className="w-8 border-yellow-500 border-4 mb-2" />
              {realWorldExperienceBlock?.title && (
                <h2 className="text-blue-500 font-bold tracking-tighter text-xl md:text-4xl mb-1 md:mb-3 leading-none">
                  {realWorldExperienceBlock.title}
                </h2>
              )}
              {realWorldExperienceBlock?._rawBody && (
                <Intro>
                  <BlockContent blocks={realWorldExperienceBlock._rawBody} />
                </Intro>
              )}
            </div>
          </div>
        </div>
      )}
      <div className="max-w-7xl mx-auto px-4">
        <ul className="flex flex-wrap mx-auto justify-center items-center">
          {realWorldExperienceBlock.logos.map((logo) => (
            <li
              key={logo._key}
              className="w-1/2 sm:w-3/12 md:w-2/12 lg:w-40 overflow-hidden"
            >
              {logo.asset && (
                <Image
                  {...logo}
                  width={352}
                  className="p-2 align-top"
                  alt={logo.alt || ``}
                />
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default RealWorldExperienceBlock;
